import { mixtilesAxios } from '../utils/ApiUtils'
import { API_METHODS, callApi, createApiFunction } from './apiProvider'
import UserManager from '../services/UserManager'

const PATH = 'user-cart'

export const getUserCartApi = async (cartId) => {
  const response = await mixtilesAxios.get(`${PATH}/${cartId}`)
  return response.data
}

export const saveUserCartApi = ({
  cartId,
  cartItems,
  previewItems,
  tilePreviewSpecs,
  photoBookCoverUrl,
  photoBookCoverCaption,
  aiPreviews,
}) =>
  // Through callApi so a logged-in saver's token goes along: the backend keeps the cart's photos the account can access
  callApi(
    createApiFunction(API_METHODS.POST, PATH, {
      cartId,
      cartItems,
      previewItems,
      tilePreviewSpecs,
      email: UserManager.getUserEmail(),
      photoBookCoverUrl,
      photoBookCoverCaption,
      aiPreviews,
    })
  )
